import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import { useCart } from "../../Services/Common/CartContext";
import "../../styles/Header-css/Hedaer/Header.css";
import logo_0 from "../../../assets/images/R2R.png";
import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaTwitter,
  FaGlobe,
  FaUserCircle,
} from "react-icons/fa";

import LocationInput from "../Header Location/LocationInput";
import SearchInput from "../Header search/SearchInput";
import LoginModal from "../loginmodel/LoginModal";
import QuickActionModal from "../QuickAction/QuickActionModal";
import HeaderCart from "./HeaderCart";

const Header = ({ setSearchTerm = () => {} }) => {
  const [showSocialPopup, setShowSocialPopup] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("isLoggedIn") === "true"
  );
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showQuickActionModal, setShowQuickActionModal] = useState(false);
  const [activeTitle, setActiveTitle] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Get cart count from context
  // const { cartItemsCount } = useCart();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSocialPopup = () => setShowSocialPopup((prev) => !prev);

  const handleAccountClick = (event) => {
    event.stopPropagation();
    if (isMobile) {
      setActiveTitle(activeTitle === "ACCOUNT" ? null : "ACCOUNT");
    }
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    localStorage.setItem("isLoggedIn", "true");
    setShowLoginModal(false);
    setActiveTitle(null);
  };

  const handleLogout = (event) => {
    event.stopPropagation();
    setIsLoggedIn(false);
    localStorage.removeItem("isLoggedIn");
    setActiveTitle(null);
  };

  const handleMouseLeave = () => {
    if (!isMobile) setActiveTitle(null);
  };

  const handleShowLoginModal = (event) => {
    event.stopPropagation();
    setShowLoginModal(true);
  };

  const handleCartClick = () => {
    // Navigate to cart page or show cart modal
    window.location.href = '/cart';
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          {/* Logo + Location/Search */}
          <div className="logo-location-container">
            <a href="/">
            <img src={logo_0} className="header-logo" alt="R2R Logo" />
            </a>
           
            <div className="header-location-search">
              <LocationInput
                selectedLocation={selectedLocation}
                setSelectedLocation={setSelectedLocation}
              />
              <SearchInput setSearchTerm={setSearchTerm} />
            </div>
          </div>

          {/* Right-side icons/buttons */}
          <div className="header-icons header-icons-right">
            <Link to="/partner-join" className="header-link-btn">
              Service Partner
            </Link>

            <button
              className="header-link-btn primary"
              onClick={() => {
                setShowQuickActionModal(true);
                setActiveTitle(null);
              }}
            >
              Quick Action
            </button>

            {/* Cart Icon */}
            <HeaderCart
              // cartItemsCount={cartItemsCount} 
              onCartClick={handleCartClick}
            />

            {/* Account Icon */}
            <div
              className="nav-item"
              onMouseEnter={!isMobile ? () => setActiveTitle("ACCOUNT") : null}
              onMouse={!isMobile ? handleMouseLeave : null}
              onClick={handleAccountClick}
            >
              <FaUserCircle className="media-icon" />
              {activeTitle === "ACCOUNT" && (
                <div className="dropdown">
                  {isLoggedIn ? (
                    <button onClick={handleLogout}>Logout</button>
                  ) : (
                    <button onClick={handleShowLoginModal}>Login</button>
                  )}
                </div>
              )}
            </div>

            {/* Globe Icon */}
            <div
              className="header-globe-popup"
              onMouseEnter={() => setShowSocialPopup(true)}
              onMouseLeave={() => setShowSocialPopup(false)}
            >
              <FaGlobe className="globe-icon" />
              {showSocialPopup && (
                <div className="social-popup">
                  <a href="#"><FaFacebookF /></a>
                  <a href="#"><FaInstagram /></a>
                  <a href="#"><FaWhatsapp /></a>
                  <a href="#"><FaTwitter /></a>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Modals */}
      {showLoginModal && (
        <LoginModal
          onClose={() => setShowLoginModal(false)}
          onLoginSuccess={handleLoginSuccess}
        />
      )}

      {showQuickActionModal && (
        <QuickActionModal onClose={() => setShowQuickActionModal(false)} />
      )}
    </>
  );
};

export default Header;